// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"e39fb35b","453":"03346f77","455":"4d0583d5","762":"ca75ae31"}[chunkId] + ".chunk.js";
};